import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { findDOMNode } from 'react-dom'
import { FormattedMessage } from 'react-intl'
import Avatar from 'material-ui/Avatar'
import images from '../../../config/images'
import { avatarStyles, Role, UserName } from './styles'
import { checkAdminUrl, getImageURI } from '../../../lib'
import ProfileDropDown from './ProfileDropDown'

class Profile extends Component {
  constructor (props) {
    super(props)

    this.state = {
      popOverOpen: false,
      anchorEl: null
    }
  }

  handleClick = e => {
    e.preventDefault()
    const node = findDOMNode(this)
    this.setState({
      popOverOpen: true,
      anchorEl: node
    })
  }

  handleRequestClose = () => {
    this.setState({
      popOverOpen: false
    })
  }

  render () {
    const imageURI = getImageURI(this.props.userid, images.avatar)
    const opacity_admin = checkAdminUrl(this.props.location) ? 1 : 0.5
    const opacity_guest = checkAdminUrl(this.props.location) ? 0.5 : 1

    return (
      <div className="h-100 flex items-center pr3 pointer">
        {(this.props.accountType !== 'guest' && this.props.accountType !== 'free_guest') && (
          <Link
            className="pr3"
            style={{
              color: 'white',
              opacity: opacity_admin,
              textDecoration: 'none'
            }}
            to={'/admin'}
          >
            <div style={{padding: '20px', whiteSpace: 'nowrap'}}>
              {<FormattedMessage id="loggedInNavigation.adminDashboard"/>}
            </div>
          </Link>
        )}


        {(this.props.accountType !== 'free_admin' || this.props.accountType !== 'admin') && (
          <Link
            className="pr7"
            style={{
              color: 'white',
              opacity: opacity_guest,
              textDecoration: 'none'
            }}
            to={'/'}
          >
            <div style={{padding: '20px', whiteSpace: 'nowrap'}}>
              {<FormattedMessage id="loggedInNavigation.guestDashboard"/>}
            </div>
          </Link>
        )}

        <a href="https://drive.google.com/file/d/1E6VKNCwUfo552mpxFTHxziChU3ooX1hh/view" className="pr3"
           style={{color: 'white', opacity: 0.5, textDecoration: 'none'}}>
          <div style={{padding: '20px', whiteSpace: 'nowrap'}}>
            <FormattedMessage id="loggedInNavigation.manual"/>
          </div>
        </a>

        {checkAdminUrl(this.props.location) && (
          <Link
            className="pr3"
            style={{color: 'white', opacity: 0.5, textDecoration: 'none'}}
            to={'/admin'}
          >
            <div onClick={() => {
              let locale = localStorage.getItem('locale')
              if (locale == 'ja') {
                localStorage.setItem('locale', 'en')
              } else {
                localStorage.setItem('locale', 'ja')
              }
              window.location.reload()
            }}
                 style={{padding: '20px', whiteSpace: 'nowrap'}}>
              {'日本語/English'}
            </div>
          </Link>
        )}

        {!checkAdminUrl(this.props.location) && (
          <Link
            className="pr3"
            style={{color: 'white', opacity: 0.5, textDecoration: 'none'}}
            to={'/'}
          >
            <div onClick={() => {
              let locale = localStorage.getItem('locale')
              if (locale == 'ja') {
                localStorage.setItem('locale', 'en')
              } else {
                localStorage.setItem('locale', 'ja')
              }
              window.location.reload()
            }}
                 style={{padding: '20px', whiteSpace: 'nowrap'}}>
              {'日本語/English'}
            </div>
          </Link>
        )}

        <div
          className="h-100 flex items-center pr3 pointer"
          onClick={this.handleClick}
        >
          <div className="tr pr3 flex flex-column justify-between">
            <UserName>{this.props.name}</UserName>
            <Role>
              {this.props.role === 'Adminstrator' ? (
                <FormattedMessage id="loggedInNavigation.roleAdmin"/>
              ) : (
                <FormattedMessage id="loggedInNavigation.roleGuest"/>
              )}
            </Role>
          </div>
          <Avatar style={avatarStyles} src={imageURI} size={30}/>
          <ProfileDropDown
            location={this.props.location}
            newSeminarUpgradeModal={this.props.newSeminarUpgradeModal}
            popOverOpen={this.state.popOverOpen}
            anchorEl={this.state.anchorEl}
            anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
            targetOrigin={{horizontal: 'right', vertical: 'top'}}
            onRequestClose={this.handleRequestClose}
            userid={this.props.userid}
            email={this.props.email}
            name={this.props.name}
            accountType={this.props.accountType}
            logoutUser={this.props.logoutUser}
            logoutSuccess={this.props.logoutSuccess}
            recieveLoginstatus={this.props.recieveLoginstatus}
            shouldRedirectUser={this.props.shouldRedirectUser}
            upgradeUser={this.props.upgradeUser}
          />
        </div>
      </div>
    )
  }
}

export default Profile



// WEBPACK FOOTER //
// ./src/components/Profile/NavBarProfile/Profile.js